export const snap = (v: number, grid = 0.05): number => Math.round(Math.round(v / grid) * grid * 1000) / 1000;
